import { AuthAuthPermissions } from '@robovision/rvai-auth'
import type { RvaiAbilityBuilder } from '../types'


export function defineConnectedPlatformDeploymentAbility (
  builder: RvaiAbilityBuilder,
  permissions: AuthAuthPermissions[],
): void {
  const { can } = builder

  const canCRUDConnectedPlatformDeployment = (
    permissions.includes(AuthAuthPermissions.SYSTEM_MANAGEMENT) ||
    permissions.includes(AuthAuthPermissions.INFERENCE)
  )
  if (canCRUDConnectedPlatformDeployment) {
    can('crud', 'ConnectedPlatformDeployment')
  }
}
